import React, { useState } from 'react';
import { Menu, X, Phone, Mail, MapPin, Clock, ChevronDown, CreditCard, Wrench, UserCircle, ClipboardList, KeyRound, BarChart3, Sparkles, Home, Building, Warehouse, Users, Target } from 'lucide-react';
import { Button } from './ui/Button';
const residentLinks = [{
  name: 'Pay Rent & HOA',
  href: '#',
  icon: CreditCard,
  description: 'Make a payment online'
}, {
  name: 'Maintenance Request',
  href: '#',
  icon: Wrench,
  description: 'Submit a repair request'
}, {
  name: 'Resident Portal',
  href: '#',
  icon: UserCircle,
  description: 'Access your account'
}, {
  name: 'Move-In Checklist',
  href: '#',
  icon: ClipboardList,
  description: 'Get started guide'
}];
const ownerLinks = [{
  name: 'Owner Portal',
  href: '#',
  icon: KeyRound,
  description: 'Access your owner account'
}, {
  name: 'Rent Analysis',
  href: '#',
  icon: BarChart3,
  description: 'See what your property can earn'
}, {
  name: 'New Owners',
  href: '#',
  icon: Sparkles,
  description: 'Get started with us'
}];
const serviceLinks = [{
  name: 'Residential Management',
  href: '#',
  icon: Home,
  description: 'Single-family, apartments & multi-unit'
}, {
  name: 'HOA Management',
  href: '#',
  icon: Building,
  description: 'Association financials & vendor coordination'
}, {
  name: 'Commercial Properties',
  href: '#',
  icon: Warehouse,
  description: 'Retail, office & industrial management'
}];
const aboutLinks = [{
  name: 'Employee Directory',
  href: '#',
  icon: Users,
  description: 'Meet our team'
}, {
  name: 'Our Mission',
  href: '#',
  icon: Target,
  description: 'What drives us forward'
}];
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [residentsOpen, setResidentsOpen] = useState(false);
  const [ownersOpen, setOwnersOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full shadow-md" data-id="element-127">
      {/* Top NAP bar */}
      <div className="bg-[oklch(0.97_0.01_250)] text-[oklch(0.35_0.08_250)]" data-id="element-128">
        <div className="container mx-auto px-4 flex items-center justify-between h-11 text-sm font-medium" data-id="element-129">
          <div className="hidden md:flex items-center gap-5" data-id="element-130">
            <a href="tel:5594865600" className="flex items-center gap-1.5 hover:text-primary transition-colors" data-id="element-131">
              <Phone className="h-3.5 w-3.5" data-id="element-132" />
              (559) 486-5600
            </a>
            <a href="mailto:info@fresnomanagement.com" className="flex items-center gap-1.5 hover:text-primary transition-colors" data-id="element-133">
              <Mail className="h-3.5 w-3.5" data-id="element-134" />
              info@fresnomanagement.com
            </a>
          </div>
          <div className="flex items-center gap-5 mx-auto md:mx-0" data-id="element-135">
            <span className="flex items-center gap-1.5" data-id="element-136">
              <MapPin className="h-3.5 w-3.5" data-id="element-137" />
              7575 N Del Mar Ave Ste 102, Fresno CA 93711
            </span>
            <span className="hidden sm:flex items-center gap-1.5" data-id="element-138">
              <Clock className="h-3.5 w-3.5" data-id="element-139" />
              Mon–Fri 8AM–5PM
            </span>
          </div>
        </div>
      </div>

      {/* Main nav */}
      <div className="bg-white" data-id="element-140">
        <div className="container mx-auto px-4 h-20 flex items-center justify-between" data-id="element-141">
          <a href="#" className="flex items-center gap-2 shrink-0" data-id="element-142">
            <img src="https://cdn.magicpatterns.com/uploads/kuZyhrxLAUnbAoqB6LL6kM/FMC-1920w.jpg.webp" alt="Fresno Management Company Logo" className="max-h-14 w-auto object-contain" data-id="element-143" />
          </a>

          <nav className="hidden lg:flex items-center gap-8" data-id="element-144">
            {/* Services dropdown */}
            <div className="relative group/services" data-id="element-145">
              <button className="text-base font-medium text-foreground/70 hover:text-foreground transition-colors flex items-center gap-1 py-1" data-id="element-146">
                Services
                <ChevronDown className="h-3.5 w-3.5 transition-transform group-hover/services:rotate-180" data-id="element-147" />
              </button>
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-3 opacity-0 invisible group-hover/services:opacity-100 group-hover/services:visible transition-all duration-200" data-id="element-148">
                <div className="bg-white rounded-xl shadow-xl border border-border/60 p-2 w-72" data-id="element-149">
                  {serviceLinks.map(item => <a key={item.name} href={item.href} className="flex items-start gap-3 px-3 py-3 rounded-lg hover:bg-muted transition-all duration-200 hover:translate-x-0.5 group/item" data-id="element-150">
                      <div className="mt-0.5 p-1.5 rounded-md bg-muted text-primary group-hover/item:bg-primary group-hover/item:text-primary-foreground transition-all duration-200" data-id="element-151">
                        <item.icon className="h-4 w-4" data-id="element-152" />
                      </div>
                      <div data-id="element-153">
                        <div className="text-sm font-medium text-foreground" data-id="element-154">
                          {item.name}
                        </div>
                        <div className="text-xs text-muted-foreground mt-0.5" data-id="element-155">
                          {item.description}
                        </div>
                      </div>
                    </a>)}
                </div>
              </div>
            </div>

            <a href="#" className="text-base font-medium text-foreground/70 hover:text-foreground transition-colors relative py-1 after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-primary after:rounded-full after:transition-all after:duration-300 hover:after:w-full" data-id="element-156">
              Vacancies
            </a>

            {/* Residents dropdown */}
            <div className="relative group" data-id="element-157">
              <button className="text-base font-medium text-foreground/70 hover:text-foreground transition-colors flex items-center gap-1 py-1" data-id="element-158">
                Residents
                <ChevronDown className="h-3.5 w-3.5 transition-transform group-hover:rotate-180" data-id="element-159" />
              </button>
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200" data-id="element-160">
                <div className="bg-white rounded-xl shadow-xl border border-border/60 p-2 w-72" data-id="element-161">
                  {residentLinks.map(item => <a key={item.name} href={item.href} className="flex items-start gap-3 px-3 py-3 rounded-lg hover:bg-muted transition-all duration-200 hover:translate-x-0.5 group/item" data-id="element-162">
                      <div className="mt-0.5 p-1.5 rounded-md bg-muted text-primary group-hover/item:bg-primary group-hover/item:text-primary-foreground transition-all duration-200" data-id="element-163">
                        <item.icon className="h-4 w-4" data-id="element-164" />
                      </div>
                      <div data-id="element-165">
                        <div className="text-sm font-medium text-foreground" data-id="element-166">
                          {item.name}
                        </div>
                        <div className="text-xs text-muted-foreground mt-0.5" data-id="element-167">
                          {item.description}
                        </div>
                      </div>
                    </a>)}
                </div>
              </div>
            </div>

            {/* Owners dropdown */}
            <div className="relative group/owners" data-id="element-168">
              <button className="text-base font-medium text-foreground/70 hover:text-foreground transition-colors flex items-center gap-1 py-1" data-id="element-169">
                Owners
                <ChevronDown className="h-3.5 w-3.5 transition-transform group-hover/owners:rotate-180" data-id="element-170" />
              </button>
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-3 opacity-0 invisible group-hover/owners:opacity-100 group-hover/owners:visible transition-all duration-200" data-id="element-171">
                <div className="bg-white rounded-xl shadow-xl border border-border/60 p-2 w-72" data-id="element-172">
                  {ownerLinks.map(item => <a key={item.name} href={item.href} className="flex items-start gap-3 px-3 py-3 rounded-lg hover:bg-muted transition-all duration-200 hover:translate-x-0.5 group/item" data-id="element-173">
                      <div className="mt-0.5 p-1.5 rounded-md bg-muted text-primary group-hover/item:bg-primary group-hover/item:text-primary-foreground transition-all duration-200" data-id="element-174">
                        <item.icon className="h-4 w-4" data-id="element-175" />
                      </div>
                      <div data-id="element-176">
                        <div className="text-sm font-medium text-foreground" data-id="element-177">
                          {item.name}
                        </div>
                        <div className="text-xs text-muted-foreground mt-0.5" data-id="element-178">
                          {item.description}
                        </div>
                      </div>
                    </a>)}
                </div>
              </div>
            </div>

            {/* About Us dropdown */}
            <div className="relative group/about" data-id="element-179">
              <button className="text-base font-medium text-foreground/70 hover:text-foreground transition-colors flex items-center gap-1 py-1" data-id="element-180">
                About Us
                <ChevronDown className="h-3.5 w-3.5 transition-transform group-hover/about:rotate-180" data-id="element-181" />
              </button>
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-3 opacity-0 invisible group-hover/about:opacity-100 group-hover/about:visible transition-all duration-200" data-id="element-182">
                <div className="bg-white rounded-xl shadow-xl border border-border/60 p-2 w-72" data-id="element-183">
                  {aboutLinks.map(item => <a key={item.name} href={item.href} className="flex items-start gap-3 px-3 py-3 rounded-lg hover:bg-muted transition-all duration-200 hover:translate-x-0.5 group/item" data-id="element-184">
                      <div className="mt-0.5 p-1.5 rounded-md bg-muted text-primary group-hover/item:bg-primary group-hover/item:text-primary-foreground transition-all duration-200" data-id="element-185">
                        <item.icon className="h-4 w-4" data-id="element-186" />
                      </div>
                      <div data-id="element-187">
                        <div className="text-sm font-medium text-foreground" data-id="element-188">
                          {item.name}
                        </div>
                        <div className="text-xs text-muted-foreground mt-0.5" data-id="element-189">
                          {item.description}
                        </div>
                      </div>
                    </a>)}
                </div>
              </div>
            </div>

            <a href="#" className="text-base font-medium text-foreground/70 hover:text-foreground transition-colors relative py-1 after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-primary after:rounded-full after:transition-all after:duration-300 hover:after:w-full" data-id="element-190">
              Contact
            </a>
          </nav>

          <div className="hidden lg:flex items-center gap-3" data-id="element-191">
            {/* Pay Dues dropdown */}
            <div className="relative group/dues" data-id="element-192">
              <Button variant="outline" className="font-medium text-base px-6 py-3 h-12 gap-2" data-id="element-193">
                Pay Dues
                <ChevronDown className="h-4 w-4 transition-transform group-hover/dues:rotate-180" data-id="element-194" />
              </Button>
              <div className="absolute top-full right-0 pt-2 opacity-0 invisible group-hover/dues:opacity-100 group-hover/dues:visible transition-all duration-200" data-id="element-195">
                <div className="bg-white rounded-xl shadow-xl border border-border/60 p-2 w-56" data-id="element-196">
                  <a href="#" className="flex items-center gap-3 px-4 py-3.5 rounded-lg hover:bg-muted transition-all duration-200 hover:translate-x-0.5 group/item" data-id="element-197">
                    <div className="p-2 rounded-lg bg-muted group-hover/item:bg-primary group-hover/item:text-primary-foreground transition-all duration-200" data-id="element-198">
                      <CreditCard className="h-5 w-5" data-id="element-199" />
                    </div>
                    <div data-id="element-200">
                      <div className="text-sm font-medium text-foreground" data-id="element-201">
                        Pay Rent
                      </div>
                      <div className="text-xs text-muted-foreground" data-id="element-202">
                        Monthly rent payment
                      </div>
                    </div>
                  </a>
                  <div className="mx-3 my-1 h-px bg-border/60" data-id="element-203" />
                  <a href="#" className="flex items-center gap-3 px-4 py-3.5 rounded-lg hover:bg-muted transition-all duration-200 hover:translate-x-0.5 group/item" data-id="element-204">
                    <div className="p-2 rounded-lg bg-muted group-hover/item:bg-primary group-hover/item:text-primary-foreground transition-all duration-200" data-id="element-205">
                      <ClipboardList className="h-5 w-5" data-id="element-206" />
                    </div>
                    <div data-id="element-207">
                      <div className="text-sm font-medium text-foreground" data-id="element-208">
                        Pay HOA Fees
                      </div>
                      <div className="text-xs text-muted-foreground" data-id="element-209">
                        Association dues
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <Button className="font-medium shadow-md text-base px-7 py-3 h-12" data-id="element-210">
              Search Properties
            </Button>
          </div>

          <button className="lg:hidden p-2 text-foreground" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle mobile menu" data-id="element-211">
            {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-212" /> : <Menu className="h-6 w-6" data-id="element-213" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && <div className="lg:hidden border-t bg-white px-4 py-6 space-y-4 shadow-lg" data-id="element-214">
          <nav className="flex flex-col gap-1" data-id="element-215">
            {/* Services expandable */}
            <div data-id="element-216">
              <button className="w-full flex items-center justify-between text-base font-medium text-foreground py-2" onClick={() => setServicesOpen(!servicesOpen)} data-id="element-217">
                Services
                <ChevronDown className={`h-4 w-4 transition-transform ${servicesOpen ? 'rotate-180' : ''}`} data-id="element-218" />
              </button>
              {servicesOpen && <div className="ml-2 pl-3 border-l-2 border-primary/20 space-y-1 pb-2" data-id="element-219">
                  {serviceLinks.map(item => <a key={item.name} href={item.href} className="flex items-center gap-2.5 py-2 text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-220">
                      <item.icon className="h-4 w-4 text-primary" data-id="element-221" />
                      {item.name}
                    </a>)}
                </div>}
            </div>

            <a href="#" className="text-base font-medium text-foreground py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-222">
              Vacancies
            </a>

            {/* Residents expandable */}
            <div data-id="element-223">
              <button className="w-full flex items-center justify-between text-base font-medium text-foreground py-2" onClick={() => setResidentsOpen(!residentsOpen)} data-id="element-224">
                Residents
                <ChevronDown className={`h-4 w-4 transition-transform ${residentsOpen ? 'rotate-180' : ''}`} data-id="element-225" />
              </button>
              {residentsOpen && <div className="ml-2 pl-3 border-l-2 border-primary/20 space-y-1 pb-2" data-id="element-226">
                  {residentLinks.map(item => <a key={item.name} href={item.href} className="flex items-center gap-2.5 py-2 text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-227">
                      <item.icon className="h-4 w-4 text-primary" data-id="element-228" />
                      {item.name}
                    </a>)}
                </div>}
            </div>

            {/* Owners expandable */}
            <div data-id="element-229">
              <button className="w-full flex items-center justify-between text-base font-medium text-foreground py-2" onClick={() => setOwnersOpen(!ownersOpen)} data-id="element-230">
                Owners
                <ChevronDown className={`h-4 w-4 transition-transform ${ownersOpen ? 'rotate-180' : ''}`} data-id="element-231" />
              </button>
              {ownersOpen && <div className="ml-2 pl-3 border-l-2 border-primary/20 space-y-1 pb-2" data-id="element-232">
                  {ownerLinks.map(item => <a key={item.name} href={item.href} className="flex items-center gap-2.5 py-2 text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-233">
                      <item.icon className="h-4 w-4 text-primary" data-id="element-234" />
                      {item.name}
                    </a>)}
                </div>}
            </div>

            {/* About Us expandable */}
            <div data-id="element-235">
              <button className="w-full flex items-center justify-between text-base font-medium text-foreground py-2" onClick={() => setAboutOpen(!aboutOpen)} data-id="element-236">
                About Us
                <ChevronDown className={`h-4 w-4 transition-transform ${aboutOpen ? 'rotate-180' : ''}`} data-id="element-237" />
              </button>
              {aboutOpen && <div className="ml-2 pl-3 border-l-2 border-primary/20 space-y-1 pb-2" data-id="element-238">
                  {aboutLinks.map(item => <a key={item.name} href={item.href} className="flex items-center gap-2.5 py-2 text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-239">
                      <item.icon className="h-4 w-4 text-primary" data-id="element-240" />
                      {item.name}
                    </a>)}
                </div>}
            </div>

            <a href="#" className="text-base font-medium text-foreground py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-241">
              Contact
            </a>
          </nav>
          <div className="flex flex-col gap-3 pt-4 border-t" data-id="element-242">
            <Button variant="outline" className="w-full justify-center font-medium text-base h-12 gap-2" data-id="element-243">
              <CreditCard className="h-4 w-4" data-id="element-244" />
              Pay Rent
            </Button>
            <Button variant="outline" className="w-full justify-center font-medium text-base h-12 gap-2" data-id="element-245">
              <CreditCard className="h-4 w-4" data-id="element-246" />
              Pay HOA Fees
            </Button>
            <Button className="w-full justify-center font-medium text-base h-12" data-id="element-247">
              Search Properties
            </Button>
          </div>
        </div>}
    </header>;
}